module.exports = __webpack_public_path__ + "/login_ui/img/no-97e8bacc289732f81eec47f0dae86965.svg";